var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ton",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "binancecoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    rx: 7,
    fill: "#fd9903"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M15,7h6.31a2.61,2.61,0,0,1,2.76,2.06,2.8,2.8,0,0,1-.33,2.18L17,22.8l-1.08,1.86a1,1,0,0,1-1.82,0c-2.57-4.47-5.13-9-7.72-13.43A2.92,2.92,0,0,1,5.93,9,2.62,2.62,0,0,1,8.52,7Zm1,13.55h.07c.45-.77.9-1.55,1.36-2.32C18.92,15.62,20.47,13,22,10.34c.46-.8.12-1.4-.8-1.41H16.29C16,8.93,16,9,16,9.26Zm-2,0h.07V9.28c0-.2,0-.35-.27-.35H8.69c-.79,0-1.05.5-.67,1.17l5.37,9.36Z",
    transform: "translate(30.016 30.237) rotate(180)",
    fill: "#fefefe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotcoin);
export default __webpack_public_path__ + "static/media/notcoin.6d019c46516c23bc494eb0e880814611.svg";
export { ForwardRef as ReactComponent };